import config from '@/config'
import router from '@/router'
import {
  ROUTE_NAMES,
} from '@/constant/routes'

const SET_PREVIOUS_ROUTE = 'SET_PREVIOUS_ROUTE'

const _state = {
  previousRoute: null,
}

const _getters = {
  isEnableAddinPowerpoint: (_, __, rootState) => rootState.isEnableAddinPowerpoint,
  isGuestUser: (_, __, rootState) => rootState.currentUser.isGuest,
  workingMode: (_, __, rootState) => rootState.workingMode,
  previousRoute: (state) => state.previousRoute,
  isDemoMode: (_, __, rootState) => rootState.isDemoMode,
  isEnableBackActionV4: (_, __, ___, rootGetters) => {
    return rootGetters['featureToggles/isFeatureEnabled']('release-back-action-v4')
  },
  hasResizableSlideNotes: (_, getters, ___, rootGetters) => {
    if (rootGetters.isBackstage || getters.isEnableAddinPowerpoint) {
      return false
    }
    return rootGetters['featureToggles/isFeatureEnabled']('resizable-slide-notes')
  },
}

// Transitional routes are routes that are not true pages, but they are used to transition to other routes, so it it not comparable in the logic of backAction below
const TRANSITIONAL_ROUTES = [
  ROUTE_NAMES.DEMO_PRESENTATION,
  ROUTE_NAMES.AUTH,
]

const TRANSITIONAL_REFERER_URLS = [
  '/pages/register',
  '/pages/login',
  '/auth',
]

const isPreviousRouteTransitional = (routeName) => {
  return TRANSITIONAL_ROUTES.includes(routeName)
}

const isReferrerTransitional = (referrer) => {
  return TRANSITIONAL_REFERER_URLS.some((url) => {
    return referrer.includes(url)
  })
}

const isReferrerEmtpy = () => {
  const { referrer } = document
  if (isReferrerTransitional(referrer)) {
    return true
  }
  return referrer === '' || referrer === undefined || referrer === null
}

const actions = {
  async backAction({ getters, dispatch }) {
    if (getters.isEnableAddinPowerpoint) {
      router.replace({ name: ROUTE_NAMES.PRESENTATIONS })
      return
    }
    if (getters.isEnableBackActionV4) {
      dispatch('backV4Action')
      return
    }
    dispatch('backV3Action')
  },
  async backV2Action({ getters, rootState }) {
    if (getters.isGuestUser) {
      window.location.href = 'https://ahaslides.com/'
      return
    }
    if (getters.workingMode === 'team') {
      router.push('/apps/team/workspace')
      return
    }

    const { previousRoute } = getters
    const currentRouteName = rootState.route.name
    const { referrer } = document
    const hasHistory = window.history.length > 1
    const isDifferentSPARoute = previousRoute.name && previousRoute.name !== currentRouteName
    const isNoReferrer = referrer === ''
    const isExternalReferrer = referrer && new URL(referrer).origin !== config.presenterDomain

    // Case 1: Back to previous SPA route
    if (isDifferentSPARoute) {
      window.history.back()
      return
    }

    // Case 2 & 3 combined: No referrer OR external referrer OR no meaningful history → Go to Presentations
    if (isNoReferrer || !hasHistory || isExternalReferrer) {
      router.push({ name: ROUTE_NAMES.PRESENTATIONS })
      return
    }

    // Case 4: Safe to go back
    window.history.back()
  },
  async backV3Action({ getters, rootState }) {
    if (getters.isGuestUser) {
      window.location.href = 'https://ahaslides.com/'
      return
    }
    if (getters.workingMode === 'team') {
      router.push('/apps/team/workspace')
      return
    }

    const { previousRoute } = getters
    const currentRouteName = rootState.route.name
    const { referrer } = document
    const hasHistory = window.history.length > 1
    const isDifferentSPARoute = previousRoute.name && previousRoute.name !== currentRouteName
    const isExternalReferrer = referrer && new URL(referrer).origin !== config.presenterDomain

    // Case 1: Back to previous SPA route
    if (isDifferentSPARoute) {
      if (isPreviousRouteTransitional(previousRoute.name)) {
        router.push({ name: ROUTE_NAMES.HOME })
      } else {
        window.history.back()
      }
      return
    }

    // Case 2 & 3 combined: No referrer OR external referrer OR no meaningful history → Go to Presentations
    if (isReferrerEmtpy() || !hasHistory || isExternalReferrer) {
      router.push({ name: ROUTE_NAMES.PRESENTATIONS })
      return
    }
    // Case 4: Safe to go back
    window.history.back()
  },
  async backV4Action({ getters, rootState }) {
    if (getters.isGuestUser) {
      window.location.href = 'https://ahaslides.com/'
      return
    }
    if (getters.workingMode === 'team') {
      router.push('/apps/team/workspace')
      return
    }

    const { previousRoute } = getters
    const currentRouteName = rootState.route.name
    const { referrer } = document
    const hasHistory = window.history.length > 1
    const isDifferentSPARoute = previousRoute.name && previousRoute.name !== currentRouteName
    const isExternalReferrer = referrer && new URL(referrer).origin !== config.presenterDomain

    // Case 1: Back to previous SPA route
    if (isDifferentSPARoute) {
      if (isPreviousRouteTransitional(previousRoute.name)) {
        router.push({ name: ROUTE_NAMES.HOME })
      } else {
        window.history.back()
      }
      return
    }

    // this is the only different between backV3Action and backV4Action
    // No referrer => isReferrerTransitional(referrer)
    // Because in production/staging, the referrer policy is different from local env
    // document.referrer is always '', when commit in-app navigation
    // it only receive value when navigation from external site
    // Case 2 & 3 combined: From SignUp/Login/SSO page OR external referrer OR no meaningful history → Go to Presentations
    if (isReferrerTransitional(referrer) || !hasHistory || isExternalReferrer) {
      router.push({ name: ROUTE_NAMES.PRESENTATIONS })
      return
    }
    // Case 4: Safe to go back
    window.history.back()
  },
  setPreviousRouteAction({ commit }, route) {
    commit(SET_PREVIOUS_ROUTE, route)
  },
}

const mutations = {
  [SET_PREVIOUS_ROUTE](state, route) {
    state.previousRoute = route
  },
}

const editor = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}

export default editor
